<div class="form-group with-select">
  <select #filterAirport
          class="form-control" 
          id="filterAirport" 
          name="filterAirport"
          [(ngModel)]="filter.airport"
          (ngModelChange)="filterChanged($event)">
    
    <option value="" disabled></option>
    <option value="LHR">Heathrow</option>
    <option value="LGW">Gatwick</option>
    <option value="LCY">London City</option>
    <option value="GVA">Geneva</option>
    
  </select>
  <label class="control-label" for="filterAirport">{{ appCopy.panelHeader['filterByAirportLabel'+selectedLanguage] }}</label>
</div>

<div class="form-group with-select">
  <select #filterType
          class="form-control" 
          id="filterType" 
          name="filterType"
          [(ngModel)]="filter.type"
          (ngModelChange)="filterChanged($event)">
    
    <option value="" disabled></option>
    <option value="ABC">ABC</option>
    <option value="SDS">SDS</option>
    
  </select>
  <label class="control-label" for="filterType">{{ appCopy.panelHeader['filterByTypeLabel'+selectedLanguage] }}</label>
</div>

<h6 class="margin-top-0 margin-bottom-8">
  {{ appCopy.panelHeader['filterByDateLabel'+selectedLanguage] }}
</h6>
<p>{{ appCopy.panelHeader['startdateText'+selectedLanguage] }}</p>
<div class="form-group date-inputs clearfix">
  <input class="form-control form-control--no-label date-inputs__day pull-left" 
        name="startDateDay" 
        id="startDateDay" 
        placeholder="{{ appCopy.panelHeader['dayPlaceholder'+selectedLanguage] }}" 
        type="number" 
        maxlength="2"
        #startDateDay
        [(ngModel)]="filter.startDateDay"
        (ngModelChange)="filterChanged($event)"
        [appAutoTab]="2">
  <input class="form-control form-control--no-label date-inputs__month pull-left"
        name="startDateMonth" 
        id="startDateMonth" 
        placeholder="{{ appCopy.panelHeader['monthPlaceholder'+selectedLanguage] }}" 
        type="number" 
        maxlength="2"
        #startDateMonth
        [(ngModel)]="filter.startDateMonth"
        (ngModelChange)="filterChanged($event)"
        [appAutoTab]="2">
  <input class="form-control form-control--no-label date-inputs__year pull_left"
        name="startDateYear" 
        id="startDateYear" 
        placeholder="{{ appCopy.panelHeader['yearPlaceholder'+selectedLanguage] }}" 
        type="number"
        minlength="4"
        #startDateYear
        [(ngModel)]="filter.startDateYear"
        (ngModelChange)="filterChanged($event)">
  <div class="date-inputs__separator"></div>
</div>
<p>{{ appCopy.panelHeader['endDateText'+selectedLanguage] }}</p>
<div class="form-group date-inputs clearfix">
  <input class="form-control form-control--no-label date-inputs__day pull-left" 
        name="endDateDay" 
        id="endDateDay" 
        placeholder="{{ appCopy.panelHeader['dayPlaceholder'+selectedLanguage] }}" 
        type="number" 
        maxlength="2"
        #endDateDay
        [(ngModel)]="filter.endDateDay"
        (ngModelChange)="filterChanged($event)"
        [appAutoTab]="2">
  <input class="form-control form-control--no-label date-inputs__month pull-left"
        name="endDateMonth" 
        id="endDateMonth" 
        placeholder="{{ appCopy.panelHeader['monthPlaceholder'+selectedLanguage] }}" 
        type="number" 
        maxlength="2"
        #endDateMonth
        [(ngModel)]="filter.endDateMonth"
        (ngModelChange)="filterChanged($event)"
        [appAutoTab]="2">
  <input class="form-control form-control--no-label date-inputs__year pull_left"
        name="endDateYear" 
        id="endDateYear" 
        placeholder="{{ appCopy.panelHeader['yearPlaceholder'+selectedLanguage] }}" 
        type="number"
        minlength="4"
        #endDateYear
        [(ngModel)]="filter.endDateYear"
        (ngModelChange)="filterChanged($event)">
  <div class="date-inputs__separator"></div>
</div>
<div class="flex flex--space-between margin-bottom-16">
  <div class="checkbox checkbox--default checkbox--small">
    <input type="checkbox" 
           name="showPast" 
           id="showPast"
           [(ngModel)]="filter.showPast"
           (ngModelChange)="filterChanged($event)">
    <label for="showPast" class="text-muted">{{ appCopy.panelHeader['showPastBookingsLabel'+selectedLanguage] }}</label>
  </div>
</div>
<div class="flex flex--space-between margin-bottom-16">
  <div class="checkbox checkbox--default checkbox--small">
    <input type="checkbox" 
           name="showCancelled" 
           id="showCancelled"
           [(ngModel)]="filter.showCancelled"
           (ngModelChange)="filterChanged($event)">
    <label for="showCancelled" class="text-muted">{{ appCopy.panelHeader['showCancelledBookingsLabel'+selectedLanguage] }}</label>
  </div>
</div>